import Icon from '@passkeys/ui/icon';
import type { MouseEvent } from 'react';
import { useEffect, useState, cloneElement } from 'react';

import useModal from '@/ui/hooks/use-modal.js';
import { cn } from '@/ui/utils/classnames';

const stopPropagation = (event: MouseEvent<HTMLDivElement>) =>
  event.stopPropagation();

function Modal() {
  const modal = useModal();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(Boolean(modal && !modal.fullscreen));
  }, [modal]);

  if (!modal || modal.fullscreen) {
    return;
  }

  const { id, reactContent, onClose, canClose = true } = modal;

  const children = cloneElement(reactContent, {
    onClose,
  });

  return (
    <div
      className={cn(
        'absolute left-0 top-0 z-[100] flex h-full w-full flex-col justify-center bg-black/25 px-12 transition-colors duration-300 theme-dark:bg-white/10',
        fadeIn ? 'bg-black/25' : 'bg-black/0',
      )}
      onClick={canClose ? onClose : undefined}
    >
      <div
        className="relative rounded-2xl bg-white p-6 theme-dark:bg-black"
        key={id}
        onClick={stopPropagation}
      >
        {children}

        {canClose && (
          <button
            onClick={onClose}
            type="button"
            className="absolute right-3 top-3"
            data-testid="close-modal-button"
          >
            <Icon name="x-mark" size={18} className="theme-dark:text-white" />
          </button>
        )}
      </div>
    </div>
  );
}

export default Modal;
